import { mapState } from 'vuex';
import VueWordCloud from 'vuewordcloud';

export default {
    name: 'wai_symptomsmap',
    props: {
        symptoms : Object,
        details : Array,
        selectedConcept : String,
        sentensesWithConcept : Array,
        selectedConceptNum : Number,
        classification : String
    },

    components: {
        VueWordCloud               
    },    

    data : function(){

        return {
            loading : false,
            addShowed : false,
            selectedGroup : null,
            negatedExcluded : false,
            groups : {
                disease : {
                    id : "disease",
                    name : "Diseases",
                    color : 'rgb(241, 36, 0)'
                },
                drag : {
                    id : "drag",
                    name : "Medicine",
                    color : '#0084FF'
                },
                symptom : {
                    id : "symptom",
                    name : "Symptom",
                    color : "#ffffff"
                },

                
            }
        }

    },

    created : () => {

    },

    mounted : function(){
        this.render()
    },

    watch: {
        symptoms : {
            //immediate: true,
            handler : function(){
                this.render()
                
            }
        } 
    },

    beforeRouteEnter (to, from, next) {
        next()
    },

    beforeRouteUpdate (to, from, next) {
        next()
    },

    computed: mapState({
        auth : state => state.auth,
        l : function(state){
            return this.$root.platform.language.get()
        },

        words : function(){

            var m = this.allwords

            var w = _.filter(m, v => {
                if( (!this.selectedGroup || v[3] == this.selectedGroup) && (!this.negatedExcluded || !v[6]) ) return true

            })

            

            return w

        },
        allwords : function(){

            var worldMap = []
            var counts = {
                c : {},
                n : {}
            }

            _.each(this.details, (d) => {
                _.each(d.concepts, (c) => {

                    var cuiinfo = this.symptoms[c.CUI]
                    var i = 'c'


                    if (cuiinfo){

                        if(c.negated){
                            i = 'n'
                        }

                        if(!counts[i][c.CUI]) 
                            counts[i][c.CUI] = {
                                cuiinfo : cuiinfo,
                                negated : c.negated,
                                count : 0
                            }

                        counts[i][c.CUI].count++

                    }
                })
            })


            var fillmap = (ss) => {
                return _.map(ss, (s) => {
                    var group = this.groups[s.cuiinfo.styclass || 'symptom']
                    var color = group.color || "#FFFFFF"
                    var name = s.cuiinfo.info?.name || s.cuiinfo.CUIName

                    if(s.negated) name = "-{" + name + "}"

                    console.log(s.cuiinfo)

                    return [name, s.count, color, group.id, s.cuiinfo.CUI, s.cuiinfo, s.negated]
                })
            }
            
            worldMap = worldMap.concat(fillmap(counts.c))
            worldMap = worldMap.concat(fillmap(counts.n))

            return worldMap

            return _.map(this.symptoms, (s) => {

                var count = 0;

                _.each(this.details, function(d){
                    _.each(d.concepts, function(sc){
                        if(sc == s.CUI) count++
                    })
                })

                var group = this.groups[s.styclass || 'symptom']
                var color = group.color || "#FFFFFF"

                var name = s.CUIName

                if(s.negated) name = "-{" + name + "}"
                

                return [name, count, color, group.id, s.CUI]

            })

        },

        height : function(){
            var count = this.words.length

            var h = 6.3 * count

            console.log('count', count)

            if(h < 100) h = 100;
            if(h > 650) h = 650

            return h
        },

        actualgroups : function(){
            var g = {}

            _.each(this.allwords, v => {
                g[v[3]] = this.groups[v[3]]
            })

            return g
        }
    }),

    methods : {
        selectConcept : function(word){

            console.log('word', word)

            this.$emit('selectConcept', word)
        },
        onWordClick : function(word){

            var cui = word[4];

            var d = _.filter(this.details, function(d){
                return _.find(d.concepts, function(sc){
                    if(sc == cui) return true
                })
            })
            
            return [d[0]]

        },
        selectGroup : function(id){
            if (this.selectedGroup == id){
                this.selectedGroup = null
            }
            else
                this.selectedGroup = id
        },

        render : function(){

        },

        lcnnum : function(){
            this.$emit('lcnnum')
            
        },

        rcnnum : function(){
            this.$emit('rcnnum')
        },

        negatedExclude : function(){
            this.negatedExcluded = !this.negatedExcluded
        },

        clear : function(){
            this.negatedExcluded = false
            this.selectedGroup = null

            this.$emit('clear')
        }
    },
}